import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { TBrand, TBrandResponse, adaptBrandFromResponse } from '../../types';
import { BACKEND_ADMIN_BRAND } from '../../backend-paths';


export const brandReadGetApi = createAsyncThunk(
	`FETCH/${BACKEND_ADMIN_BRAND}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ADMIN_BRAND}/${payload}`;

		return HttpService.get<TBrandResponse>(path).then(result => {
			return adaptBrandFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TBrand> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const brandReadSlice = createSlice({
	name: 'brandReadSlice',
	initialState,
	reducers: {
		setBrandRead(state, action: PayloadAction<TBrand>) {
			state.item = action.payload;
		},

		clearBrandRead(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[brandReadGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[brandReadGetApi.fulfilled.type]: (state, action: PayloadAction<TBrand>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[brandReadGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useBrandReadSelector = () => useAppSelector(state => state[brandReadSlice.name]);

export const { clearBrandRead, setBrandRead } = brandReadSlice.actions;
